<template>
<div class="container">
    <div class="handle-box">
        <div class="handle-left">
            <div class="search-left">
                <el-input v-model="query.realname" placeholder="用户姓名" clearable class="handle-input mr10"></el-input>
                <el-input v-model="query.phone" placeholder="手机号" clearable class="handle-input mr10"></el-input>

                <el-button type="primary" class="btn-search ml8" @click="getTableData">搜索</el-button>
                <el-button type="primary" class="btn-search ml8" @click="reset">重置</el-button>
            </div>
        </div>
    </div>
    <div class="nav-check-status">
        <el-radio-group v-model="query.status" @change="changeHandler">
            <el-radio-button label="0">未审核</el-radio-button>
            <el-radio-button label="1">已通过</el-radio-button>
            <el-radio-button label="2">未通过</el-radio-button>
        </el-radio-group>
    </div>
    <!-- 类型切换E -->
    <!-- 表格S -->
    <div class="order-detail">
        <el-table :height="tableHeight" :max-height="tableHeight" @selection-change="selectsionRow" :data="customerData" border highlight-current-row v-loading="loading">
            <el-table-column type="selection">
            </el-table-column>
            <el-table-column prop="applicant" align="center" show-overflow-tooltip label="申请者"></el-table-column>
            <el-table-column prop="visit_amount" show-overflow-tooltip label="回访">

                <template slot-scope="scope">
                    <el-link type="primary" :underline="false" @click="actions(scope.row, 'show')">{{ scope.row.visit_amount }}</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="realname" show-overflow-tooltip label="客户姓名"></el-table-column>
            <el-table-column prop="mobile" show-overflow-tooltip label="手机号"></el-table-column>
            <el-table-column prop="banquet_size" show-overflow-tooltip label="桌数"></el-table-column>
            <el-table-column prop="budget" align="center" show-overflow-tooltip label="预算"></el-table-column>
            <el-table-column prop="wedding_date" align="center" show-overflow-tooltip label="订婚日期"></el-table-column>
            <el-table-column prop="zone" show-overflow-tooltip label="区域"> </el-table-column>
            <el-table-column prop="hotel" show-overflow-tooltip label="酒店"></el-table-column>
            <el-table-column prop="platform" show-overflow-tooltip label="客资来源"></el-table-column>
            <el-table-column prop="news_type" show-overflow-tooltip label="信息类型"></el-table-column>
            <el-table-column prop="remark" align="center" show-overflow-tooltip label="备注"></el-table-column>
            <el-table-column prop="create_time" align="center" show-overflow-tooltip label="创建日期"></el-table-column>
        </el-table>
    </div>
    <!-- 表格E -->
    <!-- 表格E -->
    <div class="footer-box">
        <div class="toolBar">
            <!-- 未审核 -->
            <el-button v-if="query.status==0" type="text" icon="el-icon-share" class="mr10" @click="confirmUserId">确认回访申请</el-button>
            <el-button v-if="query.status==0" type="text" icon="el-icon-share" class="mr10" @click="rejectedUserId">驳回回访申请</el-button>
        </div>
        <div class="pagination" v-if="isPagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[10, 15, 30, 50, 100, 300, 1000]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
        </div>
    </div>
    <!-- 客资详情 -->
    <customer-detail ref="customerDetail" :auth="auth" @getTableData="getTableData"></customer-detail>
</div>
</template>

<script>
import {
    showDrawerPass,
    checkDataAuth
} from '@/utils/common.js'
import customerDetail from './confirm/detail'; // 客资详情
const query = {
    // 搜索主要条件
    realname: '', //回访状态
    phone: '', //关键字类型
    status: 0

};
export default {
    components: {
        customerDetail, // 客资详情
    },
    data() {
        let tableHeight = window.innerHeight - 300;
        let windowheight = window.innerHeight;
        return {
            query: Object.assign({}, query), // 搜索条件
            loading: false,
            tableHeight: tableHeight,
            windowheight: windowheight,
            customerData: [],
            //反映翻页
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            },
            isPagination: {},
            auth: {},
            newSelected: [],
        }
    },
    created() {
        // 验证搜索权限
        let _this = this;
        checkDataAuth().then((res) => {
            _this.auth = res;
        })
        this.getTableData();
    },
    methods: {
        // 清空筛选项
        reset() {
            this.query = Object.assign({}, query);
        },
        changeHandler(value) {
            this.query.check_status = value;
            this.pagination.page = 1;
            this.getTableData();
        },
        // 列表点击 点击详情
        actions(row, type) {
            let that = this;
            that.currentRow = row;
            switch (type) {
                // 显示
                case 'show':
                    that.$refs['customerDetail'].showCustomerDrawer(row);
                    break;
            }
        },
        //选中table当前行
        selectsionRow(rows) { //选中复选框操作
            let selected = [];
            rows.forEach(element => {
                selected.push(element.id);
            });
            this.newSelected = selected;
        },
        confirmUserId() {
            let _this = this;
            if (_this.newSelected.length == 0) {
                this.$message({
                    message: '请选择要分配的客资',
                    type: 'warning'
                });
                return false;
            }
            this.$confirm(' 是否继续此操作?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(() => {
                    let query = {
                        ids: _this.newSelected
                    };
                    let url = '/api/customer.apply/accept';
                    this.$post(url, query).then(function (response) {
                        if (response.code == 200) {
                            _this.$message({
                                type: 'success',
                                message: response.msg
                            });
                            _this.getTableData();
                        } else {
                            _this.$message.error(response.msg);
                        }

                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });

        },
        rejectedUserId() {
            let _this = this;
            if (_this.newSelected.length == 0) {
                this.$message({
                    message: '请选择要分配的客资',
                    type: 'warning'
                });
                return false;
            }
            this.$confirm(' 是否继续此操作?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(() => {
                    let query = {
                        ids: _this.newSelected
                    };
                    let url = '/api/customer.apply/reject';
                    this.$post(url, query).then(function (response) {
                        if (response.code == 200) {
                            _this.$message({
                                type: 'success',
                                message: response.msg
                            });
                            _this.getTableData();
                        } else {
                            _this.$message.error(response.msg);
                        }

                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        },
        // 获取列表数据
        getTableData(options) {
            let that = this;
            that.loading = true;
            let url = "/api/customer.apply/index"
            let query = {
                ...that.query
            };
            query['pagination'] = this.pagination;
            this.$post(url, query).then(function (response) {
                if (response.code == 200) {
                    that.customerData = response.data.list;
                    that.pagination = response.data.pagination;
                    that.loading = false;
                }
            });
        },
        // 分页
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
    }
}
</script>
<style lang="less" scoped>
@import url('@/assets/css/member.less');
</style>